module.exports = __webpack_public_path__ + "img/bxzcmh.1fa6ee3d.png";